import React, { useEffect, useRef, useState } from "react";

// Animated number counter with easing, triggered on scroll into view
export default function StatCounter({ value, prefix = "", suffix = "", label, duration = 1800 }) {
  const ref = useRef(null);
  const [displayed, setDisplayed] = useState(0);
  const startedRef = useRef(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            const start = performance.now();
            const tick = (t) => {
              const p = Math.min(1, (t - start) / duration);
              const eased = 1 - Math.pow(1 - p, 3);
              setDisplayed(Math.floor(eased * value));
              if (p < 1) requestAnimationFrame(tick);
              else setDisplayed(value);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value, duration]);

  const formatted = displayed.toLocaleString();

  return (
    <div ref={ref} className="flex flex-col gap-3" data-testid={`stat-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-mono text-4xl md:text-6xl tracking-tighter text-primary">
        {prefix}
        {formatted}
        {suffix}
      </div>
      <div className="overline text-foreground/60">{label}</div>
    </div>
  );
}
